<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600" scrollable>
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Cambiar clave
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Clave -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="clave" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.secret"
                    :error-messages="errors"
                    type="password"
                    label="Clave"
                    :append-icon="showKey ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                    :type="showKey ? 'text' : 'password'"
                    @click:append="showKey = !showKey"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            Cambiar
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    extension: {
      type: String,
    },
  },

  data() {
    return {
      isLoading: false,
      showKey: false,
      payload: { extension: "", key: "" },
    };
  },

  watch: {
    isActive() {
      this.payload = { extension: this.extension };
    },
  },

  methods: {
    closeDialog(data = false) {
      this.$emit("dialog:close", data);
      this.$refs.obs.reset();
    },

    async submitForm() {
      this.isLoading = true;

      try {
        const { data } = await PbxHttpClient.post(
          "/server_externo/extension/update_key",
          this.payload
        );

        if (data.status !== 200) throw Error;
        this.closeDialog();

        this.$snotify.success(
          `Clave ${this.isEditMode ? "actualizada" : "creada"} con éxito.`,
          "¡Hecho!"
        );
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
      this.isLoading = false;
    },
  },
};
</script>
